export const weatherIconCode = {
  THUNDERSTORM: 200,
  DRIZZLE: 300,
  RAIN: 500,
  SNOW: 600,
  ATMOSPHERE: 700,
  CLEAR: 800,
  CLOUDS: 801
};

export const geoErrors: { [key: number]: string } = {
  1: 'O usuário negou a solicitação de geolocalização.',
  2: 'As informações de localização não estão disponíveis.',
  3: 'A solicitação para obter a localização do usuário expirou.'
};
